var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 51.5625C25.1813 51.5625 28.875 47.8688 28.875 43.3125C28.875 38.7562 25.1813 35.0625 20.625 35.0625C16.0687 35.0625 12.375 38.7562 12.375 43.3125C12.375 47.8688 16.0687 51.5625 20.625 51.5625Z",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 57.75C9.69087 55.8288 11.5592 54.2695 13.7072 53.1956C15.8551 52.1216 18.2236 51.5625 20.625 51.5625C23.0264 51.5625 25.3949 52.1216 27.5428 53.1956C29.6908 54.2695 31.5591 55.8288 33 57.75",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 24.75C25.1813 24.75 28.875 21.0563 28.875 16.5C28.875 11.9437 25.1813 8.25 20.625 8.25C16.0687 8.25 12.375 11.9437 12.375 16.5C12.375 21.0563 16.0687 24.75 20.625 24.75Z",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 30.9375C9.69087 29.0163 11.5592 27.457 13.7072 26.3831C15.8551 25.3091 18.2236 24.75 20.625 24.75C23.0264 24.75 25.3949 25.3091 27.5428 26.3831C29.6908 27.457 31.5591 29.0163 33 30.9375",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.375 51.5625C49.9313 51.5625 53.625 47.8688 53.625 43.3125C53.625 38.7562 49.9313 35.0625 45.375 35.0625C40.8187 35.0625 37.125 38.7562 37.125 43.3125C37.125 47.8688 40.8187 51.5625 45.375 51.5625Z",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57.75C34.4409 55.8288 36.3092 54.2695 38.4572 53.1956C40.6051 52.1216 42.9736 51.5625 45.375 51.5625C47.7764 51.5625 50.1449 52.1216 52.2928 53.1956C54.4408 54.2695 56.3091 55.8288 57.75 57.75",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.375 24.75C49.9313 24.75 53.625 21.0563 53.625 16.5C53.625 11.9437 49.9313 8.25 45.375 8.25C40.8187 8.25 37.125 11.9437 37.125 16.5C37.125 21.0563 40.8187 24.75 45.375 24.75Z",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30.9375C34.4409 29.0163 36.3092 27.457 38.4572 26.3831C40.6051 25.3091 42.9736 24.75 45.375 24.75C47.7764 24.75 50.1449 25.3091 52.2928 26.3831C54.4408 27.457 56.3091 29.0163 57.75 30.9375",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.079c32c77a5a805766e80f51e908028b.svg";
export { ForwardRef as ReactComponent };